import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import {
  Alert,
  Chip,
  IconButton,
  TableSortLabel,
  Tooltip,
  Typography,
} from "@mui/material";
import CurrencyPoundIcon from "@mui/icons-material/CurrencyPound";
import { Box } from "@mui/system";
//import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
//import PendingOutlinedIcon from '@mui/icons-material/PendingOutlined';
//import ContrastOutlinedIcon from '@mui/icons-material/ContrastOutlined';
import RecommendOutlinedIcon from "@mui/icons-material/RecommendOutlined";
import LinkOffIcon from "@mui/icons-material/LinkOff";

interface Props {
  tableHeadings: { [key: string]: string };
  rows: any[];
}

const EditReceiptsLinkedFmeTable = ({ tableHeadings, rows }: Props) => {
  const headCells = Object.entries(tableHeadings);

  return (
    <>
      <Typography>Linked FME Records:</Typography>
      <TableContainer className="receiptsTable EditReceiptsLinkedFmeTable" sx={{ mb: 3,mt:1 }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {headCells.map(([_, value], index) => (
                <TableCell key={index} align="left">
                  <TableSortLabel>
                    {value && typeof value === "string" ? value : ""}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <React.Fragment key={row.cron_id}>
                <TableRow
                  sx={{
                    "& > *": {
                      borderBottom:
                        "1px solid rgba(224, 224, 224, 1) !important",
                    },
                  }}
                >
                  {headCells.map(([key], cellIndex) => (
                    <TableCell key={cellIndex} align="left">
                      {key === "fme" ? (
                        <div className="chip-data">
                          <>
                            <Chip
                              label={row[key] ? row[key] : "N/A"}
                              sx={{
                                backgroundColor: "#ffffff",
                                color: "rgba(0, 0, 0, 0.87)",
                                borderRadius: "5px",
                                boxShadow: "1px 1px 2px 1px #00000030",
                                height: "26px",
                                fontWeight: "500",
                                cursor: "pointer",
                                border: "1px solid #ffffff",
                                mr: 1,
                                "&:hover": {
                                  backgroundColor: "transparent",
                                  color: "#9c27b0", // slightly darker on hover
                                  border: "1px solid #9c27b0",
                                },
                              }}
                            />

                            <Tooltip title="Delete" placement="top">
                              <IconButton
                                sx={{ width: "40px", height: "40px" }}
                              >
                                <LinkOffIcon
                                  color="secondary"
                                  fontSize="small"
                                />
                              </IconButton>
                            </Tooltip>
                          </>
                        </div>
                      ) : key === "date" ? (
                        <>{row[key] ? row[key] : "N/A"} </>
                      ) : key === "fme_income" ? (
                        <>
                          <Box display={"flex"} alignItems={"center"}>
                            {row[key] ? row[key] : "N/A"}{" "}
                            <CurrencyPoundIcon
                              sx={{
                                color: "rgba(0, 0, 0, 0.56)",
                                fontSize: "20px",
                                ml: 1,
                              }}
                            />
                          </Box>
                        </>
                      ) : key === "policy_fme_income" ? (
                        <>
                          <Box display={"flex"} alignItems={"center"}>
                            {row[key] ? row[key] : "N/A"}{" "}
                            <CurrencyPoundIcon
                              sx={{
                                color: "rgba(0, 0, 0, 0.56)",
                                fontSize: "20px",
                                ml: 1,
                              }}
                            />
                          </Box>
                        </>
                      ) : key === "manual_fme_income" ? (
                        <>
                          <Box display={"flex"} alignItems={"center"}>
                            {row[key] ? row[key] : "N/A"}{" "}
                            <CurrencyPoundIcon
                              sx={{
                                color: "rgba(0, 0, 0, 0.56)",
                                fontSize: "20px",
                                ml: 1,
                              }}
                            />
                          </Box>
                        </>
                      ) : key === "covered" ? (
                        <> {row[key] ? row[key] : "N/A"}</>
                      ) : key === "fme_status" ? (
                        <>
                          <div className="AlertItems">
                            <Alert
                              icon={
                                <RecommendOutlinedIcon
                                  fontSize="inherit"
                                  sx={{ color: "rgba(1, 67, 97, 1)" }}
                                />
                              }
                              severity="info"
                              sx={{
                                border: "1px solid rgba(33, 150, 243, 0.5)",
                                padding: "0px 5px",
                                display: "inline-flex",
                              }}
                            >
                              {row[key] ? row[key] : "N/A"}
                            </Alert>

                            {/* <Alert
                                    icon={<ContrastOutlinedIcon fontSize="inherit" sx={{color:'rgba(30, 70, 32, 1)'}} />}
                                    severity="success"
                                    sx={{border:'1px solid rgba(46, 125, 50, 0.5)',padding:'0px 5px',display:'inline-flex'}}
                                  >
                                    {row[key] ? row[key] : "N/A"}
                                  </Alert>
    
                                   <Alert
                              icon={
                                <PaidOutlinedIcon
                                  fontSize="inherit"
                                  sx={{ color: "rgba(30, 70, 32, 1)" }}
                                />
                              }
                              severity="success"
                              sx={{
                                border: "1px solid rgba(46, 125, 50, 0.5)",
                                padding: "0px 5px",
                                display: "inline-flex",
                              }}
                            >
                              {row[key] ? row[key] : "N/A"}
                            </Alert>

                                  
                                   <Alert
                                    icon={<PendingOutlinedIcon fontSize="inherit" sx={{color:'rgba(1, 67, 97, 1)'}} />}
                                    severity="info"
                                    sx={{border:'1px solid rgba(33, 150, 243, 0.5)',padding:'0px 5px',display:'inline-flex'}}
                                  >
                                    {row[key] ? row[key] : "N/A"}
                                  </Alert>*/}
                          </div>
                        </>
                      ) : (
                        "N/A"
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default EditReceiptsLinkedFmeTable;
